import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

// import.meta.env exists under Vite; scripts that import app modules from
// Node (tsx) see no env and inject their own client instead.
const env = ((import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {}) as Record<string, string | undefined>;
const url = env.VITE_SUPABASE_URL;
const anonKey = env.VITE_SUPABASE_ANON_KEY;

/** False until .env names a Supabase project; the app then shows the Setup page. */
export const supabaseConfigured = Boolean(url && anonKey && !url.includes('YOUR-PROJECT-REF'));

export const supabase = createClient<Database>(url ?? 'http://localhost:54321', anonKey ?? 'anon', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

/** Throw a readable Error for a PostgREST/RPC failure. */
export function unwrap<T>(res: { data: T; error: { message: string } | null }): NonNullable<T> {
  if (res.error) throw new Error(res.error.message);
  if (res.data === null || res.data === undefined) throw new Error('No data returned');
  return res.data as NonNullable<T>;
}
